import Base from './Base';
import Member from '../models/Member';

export default class Members extends Base {
    get models() {
        const collection = this.data.map(item => new Member(item));
        collection.collection = this;

        return collection;
    }

    hasWarning(userId) {
        if (!userId) {
            return false;
        }

        return !this.models.map(m => m.id).includes(userId);
    }
}